import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage'
import { Platform } from '@ionic/angular';
import { environment } from '../../environments/environment';
/*
  Generated class for the UserDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class UserDataProvider {

  storage_instance: Storage | null = null;
  instanceID: string = '';
  userID: string | null = null;
  hasLoggedInLocal: boolean = false;

  //can be used in the future to show a tutorial after the first ever login (on this device)
  //could also be handled back-end (need to return a flag "new-user" then)
  private HAS_LOGGED_IN_ONCE:string = 'hasLoggedInOnce_V2';
  private USER_ID:string = 'userID_V2';

  constructor(public storage: Storage, private plt: Platform) {
    this.instanceID = 'UserDataProvider_' + Date.now();
  }

  init(): Promise<void> {
    if (this.storage_instance && this.storage_instance != null) {
      return Promise.resolve()
    }
    return this.storage.create().then((instance) => {
      this.storage_instance = instance;
      return Promise.all(
        [
        this.storage_instance.remove("userID"),
        this.storage_instance.get(this.USER_ID).then((value) => {
          // if an empty userid comes back we are not logged in
          if (value == null || value == undefined || value == '') {
            this.userID = null;
          }
          else {
            this.userID = value;
          }
        }),
        this.storage_instance.get(this.HAS_LOGGED_IN_ONCE).then((value) => {
          // if an empty value comes back we are not logged in
          if (value == null || value == undefined || value == '') {
            this.hasLoggedInLocal = false;
          }
          else {
            this.hasLoggedInLocal = value;
          }
        })]).then((res) => {
          console.log(this.instanceID + ': initialized; userID = ' + this.userID);
        });
      });
  }

  logout(): Promise<void> {
    return this.init().then(() => {
      this.userID = null;
      this.hasLoggedInLocal = false;
      return Promise.all([
        this.storage.remove(this.USER_ID),
        this.storage.remove(this.HAS_LOGGED_IN_ONCE)]).then((res) => {
          console.log(this.instanceID + ': ' + 'user-data.logout: remove attributes');
        });
    });
  }

  login(userID: string): Promise<void> {
    return this.init().then(() => {
      this.userID = userID;
      this.hasLoggedInLocal = true;
      console.log(this.instanceID + ': ' + 'login: logged in user = ' + userID);
      return Promise.all([
          this.storage.set(this.USER_ID, userID),
          this.storage.set(this.HAS_LOGGED_IN_ONCE, true)]).then((res) => {
            console.log(this.instanceID + ': ' + 'login after storage: logged in user = #' + userID + '#, from storage: #' + this.storage.get('userID') + '#');
          }).catch((reason) => {
            console.log('Rejection: ' + reason);
          });
    });
  }

  getUserID(): Promise<string> {
    return this.init().then(() => {
      return this.storage.get(this.USER_ID).then((value) => {
        //console.log(this.instanceID + ': ' + 'getUserID: logged in user = #' + value);
        return value;
      });
    });
  };

  isLoggedIn(): Promise<boolean> {
    return this.init().then(() => {
      if (environment.env == "dev") {
        console.log("WARNING: bypassing login in dev env!")
        this.init(). then(() => {
          this.storage.set(this.HAS_LOGGED_IN_ONCE, true);
          return this.storage.set(this.USER_ID, "7a7934ea-a9d8-4628-8a51-3f2bf578cf89").then((res) => {
            return true;
          });
        });
      }
      return this.storage.get(this.USER_ID).then((value) => {
        let result: boolean = (!(value == null || value === undefined || value == ''));
        console.log(this.instanceID + ': ' + 'isLoggedIn = ' + result + ' and userID = #' + value);
        return result;
      }).catch((reason) => { console.log(this.instanceID + ': ' + 'catch done, reason = ' + reason); return false; });
    });
  }

  isLoggedInValue(): boolean {
    let result: boolean = (!(this.hasLoggedInLocal == null || this.hasLoggedInLocal === undefined));
    if (result) {
      result = this.hasLoggedInLocal;
    }
    //console.log(this.instanceID + ': ' + 'isLoggedInValue = ' + result);
    return result;
  }

}
